import {getServerTexts as getTexts, initTexts, texts} from '../texts';

const entity = 'UI_AISEARCH';

const en = {
    // Advanced Search texts
    ai_label: 'Search with AI',
    ai_input_placeholder: 'Type here to find what you need, e.g., Documents assigned to me',
    ai_search_submit_btn: 'Go',
    no_relevant_results:
        'We did not find results for your search. Try rephrasing to find what you’re looking for. \n' +
        'Or, use the dropdown below to filter by fields and conditions.',
    ai_search_error:
        'It seems an unexpected issue occurred. Let’s try again later.\n Or, use the dropdown below to filter by fields and conditions.',
    ai_search_promotion_text: 'You can also search with our AI assistant.',
    ai_search_description:
        'Click the AI button to search using your own words, and let AI do the rest. \n' +
        'Or, use the dropdown below to filter by fields and conditions.',

    // Automation texts
    ai_box_disclaimer: 'AI results may not be accurate. Please verify before applying',
    ai_btn: 'Create with AI',
    ai_btn_promotion_tooltip: 'Create rules faster and smarter with AI, using your own words.',
    ai_btn_tooltip: 'Create rules using your own words, and let AI do the rest.',
    ai_empty_state_promotion_text:
        'To create a rule, type your own words here, and AI will do the rest.\n Or, click the New button at the top of the screen.',
    ai_box_title: 'Here you can enter your own words, and AI will create a rule for you.',
    ai_box_search_placeholder:
        'E.g., Send an email to Adam every time a sales order is approved and profit is below 10%',

    ai_box_service_error_title: 'Seems there is an issue at the moment. Please try again later.',
    ai_box_result_error_title:
        'Looks like nothing matches what you entered. Try changing it a bit or using a different way to describe it.',

    ai_box_error_subtitle: 'Try write it... '
};

const he = {
    // Advanced Search texts
    ai_label: 'חיפוש עם AI',
    ai_input_placeholder: 'כתבו כאן מה שתרצו למצוא. למשל: תעודות שאני פתחתי',
    ai_search_submit_btn: 'חיפוש',
    no_relevant_results:
        'לא מצאנו תוצאה שמתאימה למה שחיפשתם.\n' +
        'נסו לענות על השאלה: מה אני רוצה למצוא?\n' +
        'לחלופין, בחרו שדות מרשימת הבחירה מטה לסינון התוצאות והגדירו את תנאי החיפוש.\n',
    ai_search_error:
        'נתקלנו בבעיה לא צפויה. נסו שוב מאוחר יותר.\n' +
        'או, נסו לבחור שדות מרשימת הבחירה מטה לסינון התוצאות והגדירו את תנאי החיפוש.',
    ai_search_promotion_text: 'אפשר לחפש גם בעזרת AI',
    ai_search_description:
        'לחצו על כפתור AI \n' +
        'ואז כתבו במילים שלכם איזה מידע תרצו למצוא במסך.\n' +
        'או, בחרו שדות מרשימת הבחירה מטה לסינון התוצאות והגדירו את תנאי החיפוש.',

    // Automation texts
    ai_box_disclaimer: 'תוצאות ה-AI יכולות להיות לא מדויקות. מומלץ לבדוק אותן לפני השימוש.',
    ai_btn: 'ליצור עם AI',
    ai_btn_promotion_tooltip: 'אפשר לכתוב במילים שלכם חוק עסקי וליצור אותו בעזרת יכולות ה - AI',
    ai_btn_tooltip: 'אפשר לכתוב במילים שלכם חוק עסקי וליצור אותו בעזרת יכולות ',
    ai_empty_state_promotion_text:
        'אפשר לכתוב כאן במילים שלכם את החוק העסקי ויכולות ה- AI יצרו אותו, או ללחוץ על הכפתור “חדש” בראש הדף',
    ai_box_title: 'כאן תוכלו לכתוב במילים שלכם את החוק העסקי ויכולות ה - AI יצרו אותו.',
    ai_box_search_placeholder: 'למשל, לשלוח אימייל לאלון בכל פעם שהרווח בהזמנה מאושרת קטן מ - 10%',

    ai_box_service_error_title: 'נראה שהשירות לא זמין כרגע. נסו שוב מאוחר יותר.',
    ai_box_result_error_title: 'נראה שאין תוצאות שמתאימות למה שכתבתם. נסו לנסח בצורה אחרת.',

    ai_box_error_subtitle: 'Try write it... '
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'ai_label',
    2: 'ai_input_placeholder',
    3: 'ai_search_submit_btn',
    4: 'no_relevant_results',
    5: 'ai_search_error',
    6: 'ai_search_promotion_text',
    7: 'ai_btn_promotion_tooltip',
    8: 'ai_btn',
    9: 'ai_btn_tooltip',
    10: 'ai_empty_state_promotion_text',
    11: 'ai_box_title',
    12: 'ai_box_search_placeholder',
    14: 'ai_box_result_error_title',
    15: 'ai_box_service_error_title',
    30: 'ai_search_description',
    31: 'ai_box_disclaimer'
};

export async function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks according to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity] as typeof en;
